import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {DialogTitle as RmwcDialogTitle} from '@rmwc/dialog'
import '@rmwc/dialog/styles'

export const dialogTitleStyles = ({selector = '&&&'}) => css`
  ${selector} {
    font-family: 'Inter', sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 38.19px;
    padding: 1rem 2rem 1rem;
  }
`

const StyledRmwcDialogTitle = styled(RmwcDialogTitle)`
  ${dialogTitleStyles}
`

const DialogTitle = ({children, ...otherProps}) => <StyledRmwcDialogTitle {...otherProps}>{children}</StyledRmwcDialogTitle>

DialogTitle.propTypes = {
  children: PropTypes.any
}

export {DialogTitle}
